export default __webpack_public_path__ + "static/media/r3aa.10376a10.jpg";